interface WithinOneHour {
  transKey: 'within_one_hour';
  option: undefined;
}

interface NHoursAgo {
  transKey: 'n_hours_ago';
  option: { hour: number };
}

interface NDaysAgo {
  transKey: 'n_days_ago';
  option: { day: number };
}

interface NMonthsAgo {
  transKey: 'n_months_ago';
  option: { month: number };
}

interface Datetime {
  transKey: 'date_ymd';
  option: {
    year: number;
    month: number;
    day: number;
  };
}

type FormattedResult = WithinOneHour | NHoursAgo | NDaysAgo | NMonthsAgo | Datetime;

type TransKey = FormattedResult['transKey'];
type Option = FormattedResult['option'];

const millisecondsInHour = 3600000;
const millisecondsInDay = 86400000;
const millisecondsInMonths = 2592000000; // think of 1 month as 30 days

export function getDateRelative(date: Date): { transKey: TransKey; option?: Option } {
  const now = new Date();
  const diffInMilliSeconds = now.getTime() - date.getTime();
  const diffInHours = Math.floor(diffInMilliSeconds / millisecondsInHour);
  if (diffInHours < 1) {
    return { transKey: 'within_one_hour' };
  } else if (diffInHours < 24) {
    return { transKey: 'n_hours_ago', option: { hour: diffInHours } };
  }

  const diffInDays = Math.round(diffInMilliSeconds / millisecondsInDay);
  if (diffInDays < 30) {
    return { transKey: 'n_days_ago', option: { day: diffInDays } };
  }

  const diffInMonths = Math.round(diffInMilliSeconds / millisecondsInMonths);
  if (diffInMonths < 12) {
    return { transKey: 'n_months_ago', option: { month: diffInMonths } };
  }

  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return { transKey: 'date_ymd', option: { year, month, day } };
}
